var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Index"},[_c('TheHeader',{on:{"routerRefresh":_vm.routerRefresh}}),_vm._v(" "),_c('div',{staticClass:"mainBody"},[(_vm.routerAlive)?_c('TheNav'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',[(_vm.routerAlive)?_c('router-view',{on:{"routerRefresh":_vm.routerRefresh}}):_vm._e()],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02da9332","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/Index.vue
// module id = null
// module chunks = 